/* ============================================================
   Nordstealth — klebende Kaufleiste fuer Handy und Tablet.

   WARUM ES SIE BRAUCHT (gemessen, nicht vermutet):
   Produktseite bei 390px ist 10.107px lang. Der Kaufknopf sitzt bei
   y=1324 — das ist die einzige Stelle der Seite, an der gekauft werden
   kann. Ab dort liegen noch 8.783px Inhalt, auf denen ueberzeugt wird,
   ohne dass der Kunde die Entscheidung umsetzen koennte, ohne
   zurueckzuscrollen. Genau am Ende dieser Strecke steht die FAQ, also
   die Stelle mit den letzten Einwaenden.

   WIE:
   - Kein zweites Formular, kein zweiter Warenkorb-Aufruf. Die Leiste
     klickt den ECHTEN Kaufknopf. Damit gelten Variantenwahl, Bundle-
     Staffel, Ladeanzeige und Fehlermeldungen des Themes unveraendert.
   - Preis und Streichpreis werden aus dem echten Preisblock gespiegelt
     und per MutationObserver nachgezogen — waehlt jemand ein Bundle,
     stimmt die Leiste sofort.
   - Sichtbar erst, wenn der echte Knopf oben aus dem Bild gelaufen ist.
     Kommt er zurueck ins Bild, faehrt die Leiste weg: zwei gleich
     aussehende Kaufknoepfe nebeneinander wuerden nur verwirren.
   - IntersectionObserver statt Scroll-Listener — kein Layout-Thrash.
   - Ueber 750px passiert nichts (dort ist die Kaufspalte ohnehin
     klebend, Einstellung enable_sticky_info).
   ============================================================ */
/* ------------------------------------------------------------
   ABGESCHALTET auf Wunsch des Haendlers (07.08.2026).

   Die Leiste soll auf dem Handy nicht erscheinen. Der Code bleibt
   vollstaendig stehen, damit sie sich mit einer Zeile wieder
   einschalten laesst: AN auf true setzen.

   Was dadurch entfaellt: der Kaufknopf ist nach dem ersten Bildschirm
   nur noch ueber die Sprungknoepfe in den Sektionen erreichbar
   ("Jetzt sichern", "Zum Angebot", "Farbe wählen und bestellen").
   Die stehen bewusst an jedem Abschnittsende.
   ------------------------------------------------------------ */
var NS_ATC_LEISTE_AN = false;

(function () {
  // Sprachschicht: auf einer deutschen Seite gibt es window.NSI18N nicht,
  // dann bleibt der zweite Parameter stehen. snippets/ns-i18n.liquid fuellt
  // NSI18N nur fuer andere Sprachen — der deutsche Weg aendert sich nicht.
  function T(s, d) { var w = window.NSI18N; return (w && typeof w[s] === 'string') ? w[s] : d; }
  'use strict';

  if (!NS_ATC_LEISTE_AN) return;

  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  if (!MQ) return;

  function start() {
    var atc = document.querySelector('product-form button[name="add"], .main-product-atc, .product-form__submit[name="add"]');
    var form = atc && atc.closest('form');
    if (!atc || !form) return;                     // keine Produktseite
    if (document.querySelector('.ns-atc')) return; // schon gebaut

    var preisQuelle = document.querySelector('.product-page-price .price__container, .product__info-container .price__container');
    var labelQuelle = document.querySelector('.product-form__label-container .form__label');

    // --- Aufbau ---------------------------------------------------------
    var bar = document.createElement('div');
    bar.className = 'ns-atc';
    bar.setAttribute('hidden', '');

    var txt = document.createElement('div');
    txt.className = 'ns-atc__txt';
    var preis = document.createElement('div');
    preis.className = 'ns-atc__preis';
    var sub = document.createElement('div');
    sub.className = 'ns-atc__sub';
    txt.appendChild(preis);
    txt.appendChild(sub);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ns-atc__btn';

    bar.appendChild(txt);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    // --- Inhalte spiegeln ------------------------------------------------
    function knopfText() {
      // Der echte Knopf traegt seinen Text in einem <span>; daneben liegen
      // Ladeanzeige und versteckte Hilfstexte, die nicht mit sollen.
      var s = atc.querySelector('span:not(.visually-hidden)');
      var t = (s ? s.textContent : atc.textContent) || '';
      t = t.replace(/\s+/g, ' ').trim();
      return t || T('ns.js.mob.in_warenkorb', 'In den Warenkorb');
    }

    function preisText() {
      if (!preisQuelle) return '';
      var out = '';
      var jetzt = preisQuelle.querySelector('.price-item--sale, .price-item--regular');
      if (jetzt) out = jetzt.textContent.replace(/\s+/g, ' ').trim();
      var alt = preisQuelle.querySelector('.price__compare-price s, .price__compare-price .price-item--regular');
      var altText = alt ? alt.textContent.replace(/\s+/g, ' ').trim() : '';
      preis.textContent = out;
      if (altText && altText !== out) {
        var s = document.createElement('span');
        s.className = 'ns-atc__alt';
        s.textContent = altText;
        preis.appendChild(s);
      }
      return out;
    }

    function subText() {
      var t = labelQuelle ? labelQuelle.textContent.replace(/\s+/g, ' ').trim() : '';
      sub.textContent = t;
      sub.hidden = !t;
    }

    function nachziehen() {
      btn.textContent = knopfText();
      btn.disabled = !!atc.disabled;
      preisText();
      subText();
      hoeheMelden();
    }

    // Hoehe an das Stylesheet zurueckmelden, damit body unten Platz macht.
    function hoeheMelden() {
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--ns-atc-h', h + 'px');
    }

    btn.addEventListener('click', function () {
      // Der echte Knopf traegt die gesamte Warenkorb-Logik. Vorher noch
      // hinscrollen waere falsch: der Kunde will kaufen, nicht springen.
      atc.click();
    });

    // Preis- und Variantenwechsel nachziehen. Die Bundle-Staffel schreibt
    // die Preise direkt in den vorhandenen Knoten, es gibt also kein Event,
    // auf das sich horchen liesse.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(nachziehen);
      if (preisQuelle) mo.observe(preisQuelle, { childList: true, subtree: true, characterData: true });
      if (labelQuelle) mo.observe(labelQuelle, { childList: true, subtree: true, characterData: true });
      mo.observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    }

    // --- Ein- und ausblenden ---------------------------------------------
    var an = false;
    function setzen(zeigen) {
      if (zeigen === an) return;
      an = zeigen;
      if (zeigen) {
        bar.removeAttribute('hidden');
        // Ein Frame Abstand, sonst gibt es keinen Uebergang von 101%.
        requestAnimationFrame(function () {
          bar.classList.add('is-an');
          document.body.classList.add('ns-atc-an');
          hoeheMelden();
        });
      } else {
        bar.classList.remove('is-an');
        document.body.classList.remove('ns-atc-an');
      }
    }

    if ('IntersectionObserver' in window) {
      // Sichtbar, sobald der echte Knopf oben aus dem Bild ist. rootMargin
      // unten -10 % haelt die Leiste noch weg, solange der Knopf gerade so
      // am unteren Rand steht.
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!MQ.matches) { setzen(false); return; }
          var oben = e.boundingClientRect.bottom < 0;
          setzen(!e.isIntersecting && oben);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      io.observe(atc);
    }

    MQ.addEventListener ? MQ.addEventListener('change', function () { if (!MQ.matches) setzen(false); })
                        : MQ.addListener(function () { if (!MQ.matches) setzen(false); });

    window.addEventListener('resize', hoeheMelden, { passive: true });
    nachziehen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
